// import React, { useState } from "react";
// import { TreeTable } from "primereact/treetable";
// import { Column } from "primereact/column";
// import { Button } from "primereact/button";
// import "./Style.css";

// export default function TvSelection({
//   btnCopyClick,
//   btnDeleteOftheMonth,
//   NodeKeyLevel,
// }) {
//   const [CheckAll, setCheckAll] = useState(false);
//   const [CheckTV1, setCheckTV1] = useState(false);
//   const [CheckTV2, setCheckTV2] = useState(false);
//   const [CheckTV3, setCheckTV3] = useState(false);
//   const [CheckTV4, setCheckTV4] = useState(false);
//   const [CheckTV5, setCheckTV5] = useState(false);
//   const [selectedNodeKeys, setSelectedNodeKeys] = useState({});

//   const nodes = [
//     {
//       key: "0",
//       Name: "ALL",
//       children: [
//         { key: "0-0", Name: "TV 1" },
//         { key: "0-1", Name: "TV 2" },
//         { key: "0-2", Name: "TV 3" },
//         { key: "0-3", Name: "TV 4" },
//         { key: "0-4", Name: "TV 5" },
//       ],
//     },
//   ];
//   const allNodeKeys = nodes[0].children.map((child) => child.key);
//   const handleSelectionChange = (e) => {
//     const newSelectedKeys = { ...e.value };

//     const checkAllSelected = allNodeKeys.every(
//       (key) => newSelectedKeys[key]?.checked
//     );
//     setSelectedNodeKeys(newSelectedKeys);
//     setCheckAll(checkAllSelected);
//     setCheckTV1(newSelectedKeys["0-0"]?.checked || false);
//     setCheckTV2(newSelectedKeys["0-1"]?.checked || false);
//     setCheckTV3(newSelectedKeys["0-2"]?.checked || false);
//     setCheckTV4(newSelectedKeys["0-3"]?.checked || false);
//     setCheckTV5(newSelectedKeys["0-4"]?.checked || false);
//   };

//   const handleSelectAllChange = (e) => {
//     const checked = e.target.checked;
//     const newSelectedKeys = {
//       0: { checked },
//     };
//     allNodeKeys.forEach((key) => {
//       newSelectedKeys[key] = { checked };
//     });
//     setSelectedNodeKeys(newSelectedKeys);
//     setCheckAll(checked);
//     setCheckTV1(checked);
//     setCheckTV2(checked);
//     setCheckTV3(checked);
//     setCheckTV4(checked);
//     setCheckTV5(checked);
//   };
//   const save = () => {debugger
//     btnCopyClick({
//       CheckAll,
//       CheckTV1,
//       CheckTV2,
//       CheckTV3,
//       CheckTV4,
//       CheckTV5,
//       selectedNodeKeys,
//     });
//   };

//   const DeleteOftheMonth = () => {
//     btnDeleteOftheMonth({
//       CheckAll,
//       CheckTV1,
//       CheckTV2,
//       CheckTV3,
//       CheckTV4,
//       CheckTV5,
//       selectedNodeKeys,
//     });
//   };

//   const checkboxTemplate = (node) => {
//     const isParent = !node.key.includes("-");
//     const isDisabled = NodeKeyLevel === "7" && !isParent;
//     return (
//       <input
//         id="CheckBox_TVselection"
//         type="checkbox"
//         checked={selectedNodeKeys[node.key]?.checked || false}
//         disabled={isDisabled}
//         onChange={(e) =>
//           handleSelectionChange({
//             value: {
//               ...selectedNodeKeys,
//               [node.key]: { checked: e.target.checked },
//             },
//           })
//         }
//       />
//     );
//   };

//   return (
//     <>
//       <TreeTable
//         value={nodes}
//         selectionKeys={selectedNodeKeys}
//         expandedKeys={{ 0: true }}
//         onSelectionChange={handleSelectionChange}
//         className="Tree"
//       >
//         <Column
//           field="Name"
//           headerClassName="custom-header-class"
//           header="TV Selections"
//           headerStyle={{ backgroundColor: "lightgrey" }}
//           expander
//           body={(node) => (
//             <>
//               {node.key === "0" ? (
//                 <input
//                   id="CheckBox_TVselection"
//                   type="checkbox"
//                   checked={CheckAll}
//                   onChange={handleSelectAllChange}
//                 />
//               ) : (
//                 checkboxTemplate(node)
//               )}
//               {node.Name}
//             </>
//           )}
//         />
//       </TreeTable>
//       <hr />
       
//       <div className="save_delete_copymonth">
//         <Button
//           icon="pi pi-save" 
//            label="Save"
//           style={{ padding: "14px", borderRadius: "5px" }}
//           onClick={save}
//         />
//         <Button
//           icon="pi pi-trash" 
//           label="Delete"
//           style={{ padding: "14px", borderRadius: "5px" }}
//           onClick={DeleteOftheMonth}
//         />
//       </div>
//     </>
//   );
// }
import React, { useState } from "react";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import "./Style.css";

export default function TvSelection({
  btnCopyClick,
  btnDeleteOftheMonth,
  NodeKeyLevel,
}) {
  const [CheckAll, setCheckAll] = useState(NodeKeyLevel==7?true:false);
  const [CheckTV1, setCheckTV1] = useState(NodeKeyLevel==7?true:false);
  const [CheckTV2, setCheckTV2] = useState(NodeKeyLevel==7?true:false);
  const [CheckTV3, setCheckTV3] = useState(NodeKeyLevel==7?true:false);
  const [CheckTV4, setCheckTV4] = useState(NodeKeyLevel==7?true:false);
  const [CheckTV5, setCheckTV5] = useState(NodeKeyLevel==7?true:false);
  const [selectedNodeKeys, setSelectedNodeKeys] = useState(
    NodeKeyLevel === 7
      ? {
          "0-0": { checked: true },
          "0-1": { checked: true },
          "0-2": { checked: true },
          "0-3": { checked: true },
          "0-4": { checked: true },
        }
      : {}
  );

  const nodes = [
    {
      key: "0",
      Name: "ALL",
      children: [
        { key: "0-0", Name: "TV 1" },
        { key: "0-1", Name: "TV 2" },
        { key: "0-2", Name: "TV 3" },
        { key: "0-3", Name: "TV 4" },
        { key: "0-4", Name: "TV 5" },
      ],
    },
  ];
  const allNodeKeys = nodes[0].children.map((child) => child.key);

  const handleSelectionChange = (e) => {
    const newSelectedKeys = { ...e.value };

    const checkAllSelected = allNodeKeys.every(
      (key) => newSelectedKeys[key]?.checked
    );
    setSelectedNodeKeys(newSelectedKeys);
    setCheckAll(checkAllSelected);
    setCheckTV1(newSelectedKeys["0-0"]?.checked || false);
    setCheckTV2(newSelectedKeys["0-1"]?.checked || false);
    setCheckTV3(newSelectedKeys["0-2"]?.checked || false);
    setCheckTV4(newSelectedKeys["0-3"]?.checked || false);
    setCheckTV5(newSelectedKeys["0-4"]?.checked || false);
  };

  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;
    const newSelectedKeys = {
      0: { checked },
    };
    allNodeKeys.forEach((key) => {
      newSelectedKeys[key] = { checked };
    });
    setSelectedNodeKeys(newSelectedKeys);
    setCheckAll(checked);
    setCheckTV1(checked);
    setCheckTV2(checked);
    setCheckTV3(checked);
    setCheckTV4(checked);
    setCheckTV5(checked);
  };

  const save = () => { 
    // Only pass values for selected nodes where their checkbox is checked
    btnCopyClick({
      CheckAll,
      CheckTV1,
      CheckTV2,
      CheckTV3,
      CheckTV4,
      CheckTV5,
      selectedNodeKeys,
    });
  };

  const DeleteOftheMonth = () => {
    // Only pass values for selected nodes where their checkbox is checked
    btnDeleteOftheMonth({
      CheckAll,
      CheckTV1,
      CheckTV2,
      CheckTV3,
      CheckTV4,
      CheckTV5,
      selectedNodeKeys,
    });
  };

  const checkboxTemplate = (node) => {
    const isParent = !node.key.includes("-");
    const isDisabled = NodeKeyLevel === "7" && !isParent;
    return (
      <input
        id="CheckBox_TVselection"
        type="checkbox"
        checked={selectedNodeKeys[node.key]?.checked || false}
        disabled={isDisabled}
        onChange={(e) =>
          handleSelectionChange({
            value: {
              ...selectedNodeKeys,
              [node.key]: { checked: e.target.checked },
            },
          })
        }
      />
    );
  };

  return (
    <>
      {NodeKeyLevel !== "7" && (
        <TreeTable
          value={nodes}
          selectionKeys={selectedNodeKeys}
          expandedKeys={{ 0: true }}
          onSelectionChange={handleSelectionChange}
          className="Tree"
        >
          <Column
            field="Name"
            headerClassName="custom-header-class"
            header="TV Selections"
            headerStyle={{ backgroundColor: "lightgrey" }}
            expander
            body={(node) => (
              <>
                {node.key === "0" ? (
                  <input
                    id="CheckBox_TVselection"
                    type="checkbox"
                    checked={CheckAll}
                    onChange={handleSelectAllChange}
                  />
                ) : (
                  checkboxTemplate(node)
                )}
                {node.Name}
              </>
            )}
          />
        </TreeTable>
      )}
      {NodeKeyLevel === "7" && ( <h6>Do You  Want to Schedule Save Or Delete ?</h6>)}
        <div>
          
          <div className="save_delete_copymonth">
            <Button
              icon="pi pi-save"
              label="Save"
              style={{ padding: "14px", borderRadius: "5px" }}
              onClick={save}
            />
            <Button
              icon="pi pi-trash"
              label="Delete"
              style={{ padding: "14px", borderRadius: "5px" }}
              onClick={DeleteOftheMonth}
            />
          </div>
        </div>
     
    </>
  );
}
